export default {
    title: 'Configuración',
    subtitle: 'Gestionar claves API y configuraciones de servicios',
    loading: 'Cargando configuración...',
    tabs: {
        apiKeys: 'Claves API',
        serviceConfigs: 'Servicios Externos',
        preferences: 'Preferencias',
    },
    apiKeys: {
        title: 'Claves API',
        description: 'Gestionar claves API para servicios externos',
        newKey: 'Nueva Clave API',
        searchPlaceholder: 'Buscar por nombre, servicio...',
        categoryPlaceholder: 'Filtrar por categoría',
        allCategories: 'Todas las categorías',
        headers: {
            name: 'Nombre',
            service: 'Servicio',
            category: 'Categoría',
            type: 'Tipo',
            status: 'Estado',
            actions: 'Acciones',
        },
        status: {
            active: 'Activo',
            inactive: 'Inactivo',
        },
        modal: {
            edit: 'Editar Clave API',
            new: 'Nueva Clave API',
            fields: {
                name: 'Nombre',
                namePlaceholder: 'Nombre de la clave',
                service: 'Servicio',
                servicePlaceholder: 'Nombre del servicio',
                category: 'Categoría',
                type: 'Tipo',
                value: 'Valor',
                valuePlaceholder: 'Ingresa el valor de la clave',
                description: 'Descripción',
                descriptionPlaceholder: 'Descripción opcional',
            },
        },
        actions: {
            edit: 'Editar',
            delete: 'Eliminar',
        },
    },
    serviceConfigs: {
        title: 'Servicios Externos',
        description: 'Configuraciones para servicios externos',
        newService: 'Nuevo Servicio',
        searchPlaceholder: 'Buscar por nombre...',
        categoryPlaceholder: 'Filtrar por categoría',
        headers: {
            name: 'Nombre',
            category: 'Categoría',
            baseUrl: 'URL Base',
            status: 'Estado',
            actions: 'Acciones',
        },
        modal: {
            edit: 'Editar Servicio',
            new: 'Nuevo Servicio',
            fields: {
                name: 'Nombre',
                namePlaceholder: 'Nombre del servicio',
                category: 'Categoría',
                baseUrl: 'URL Base',
                baseUrlPlaceholder: 'https://api.example.com',
                config: 'Configuración JSON',
                configPlaceholder: '{"key": "value"}',
            },
        },
        actions: {
            edit: 'Editar',
            delete: 'Eliminar',
        },
    },
    modal: {
        cancel: 'Cancelar',
        save: 'Guardar Cambios',
        create: 'Crear',
        confirmDelete: '¿Estás seguro de que quieres eliminar este elemento?',
    },
};

